document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-slider');
		item.addEventListener('mouseover', () => {
			slider.swiper.slideTo(target);
			document.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('active'));
			item.classList.add('active');
		});
	});

    document.querySelectorAll('[data-swiperTabs]').forEach((item) => {
		const target = item.dataset.swipertabs ? parseInt(item.dataset.swipertabs) : 0;
		const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-slider');
		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			document.querySelectorAll('[data-swiperTabs]').forEach((itm) => itm.classList.remove('active'));
			item.classList.add('active');
		});
	});


	let imagen_tabs = document.querySelectorAll('.tabs-swiper');

	if ( imagen_tabs != null) {
		imagen_tabs.forEach( swiper => {
			new Swiper( swiper ,  {
				speed: 800,
				loop:true,
				effect: "fade",
				fadeEffect: {
					crossFade: true
				},
				pagination: {
					el: "[data-imagentabdots]",
					clickable: true
				},
				breakpoints: {
					"700": {
						allowTouchMove:false
					}
				}
			})

		});
	}
	let dining_tabs = document.querySelectorAll('.dining-swiper');

	if (dining_tabs != null) {
		dining_tabs.forEach( swiper => {
			new Swiper( swiper ,  {
				speed: 800,
				loop:true,
				effect: "fade",
				fadeEffect: {
					crossFade: true
				},
				pagination: {
					el: "[data-diningtabsdots]",
					clickable: true
				},
				breakpoints: {
					"700": {
						allowTouchMove:false
					}
				}
			})

		});
	}
	
	if (document.querySelector('.gallery-block') != null) {
		let gallery_left = new Swiper(`.gallery-swiper-left`, {
			loop: true,
			allowTouchMove: false,
			speed: 700
		})

		let gallery_middle = new Swiper(`.gallery-swiper-middle`, {
			loop: true,
			allowTouchMove: false,
			speed: 700
		})

		let gallery_right = new Swiper(`.gallery-swiper-right`, {
			loop: true,
			speed: 700,
			autoplay: {
				delay: 8000,
				disableOnInteraction: false,
			},
			pagination: {
				el: "[data-gallerydos]",
				clickable: true
			},
			navigation: {
				nextEl: '[data-gallerynext]',
				prevEl: '[data-galleryprev]'
			}
		});

		if (window.innerWidth >= 700) {
			gallery_right.controller.control = [gallery_middle, gallery_left]
		}
	}

	let threeColSlider = document.querySelectorAll('.three-columns__slider');
    if(threeColSlider){
			threeColSlider.forEach( swiper =>{
            new Swiper( swiper ,  {
                loop: true,
								watchSlidesProgress: true,
								speed:800,
								pagination: {
									el: "[data-threecoldots]",
									clickable: true
								},
								breakpoints: {
									"640": {
										slidesPerView: 1
									},
									"700": {
										slidesPerView: 2
									},
									"1200": {
										slidesPerView: 3
									}
								},
            });
        });
    }
});